import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as orderActions from './../../../../../actions/orderAction';
import * as groupActions from './../../../../../actions/groupAction';
import * as tourActions from './../../../../../actions/tourAction';
import * as userActions from './../../../../../actions/userAction';
import * as couponActions from './../../../../../actions/couponAction';
import * as vinWonderActions from './../../../../../actions/vinWonderAction';

import SaleOrder from './SaleOrder';

const mapStateToProps = state => {
    return {
        orderState: state.orderReducer,
        groupState: state.groupReducer,
        userState: state.userReducer,
        tourState: state.tourReducer,
        couponState: state.couponReducer,
        vinWonderState: state.vinWonderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllGroup: (filters = {}) => dispatch(groupActions.dataAllGroupAction({ ...filters, isSaleOrder: true })),
        getAllTour: (type) => dispatch(tourActions.dataAllTourAction({ PageIndex: 1, PageSize: 100, type })),
        getGroupDetail: (id) => dispatch(groupActions.getUpdateGroupAction({ id })),
        getAllCustomer: (filters = {}) => dispatch(userActions.getCustomerUserAction(filters)),
        exportSaleOrder: (saleOrder, refreshParams) => dispatch(orderActions.exportSaleOrder(saleOrder, refreshParams)),
        exportTourSaleOrder: (tourSaleOrder, refreshParams) => dispatch(orderActions.exportTourSaleOrder(tourSaleOrder, refreshParams)),
        getTourDetail: (id) => dispatch(tourActions.getTourDetail(id)),
        getListTourLines: (tourId, params) => dispatch(tourActions.getListTourLines(tourId, params, false, false)),
        getTourLineTickets: (departureDate, tourId, isSaleOrder) => dispatch(tourActions.getTourLineTickets({departureDate, tourId, isSaleOrder})),
        getCoupon: (couponCode, typeProduct, idProduct, quantity) => dispatch(couponActions.getCoupon(couponCode, typeProduct, idProduct, quantity)),
        clearCoupon: () => dispatch(couponActions.clearCoupon()),
        getVinWonderTypes: () => dispatch(vinWonderActions.vinWonderTypesAction()),
        getVinwonderSessions: (params) => dispatch(vinWonderActions.vinWonderSessionAction(params)),
        getVinwonderZones: () => dispatch(vinWonderActions.vinWonderZoneAction()),

    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SaleOrder));
